<template>
  <div>
    <CHeader @childEvent="getShow" :val="val"></CHeader>
    <div class="content">
      <CMenu></CMenu>
      <div class="rightContent">
        <router-view @childEvent="getShow"></router-view>
      </div>
    </div>

  </div>
</template>
<script>
  // import PersonalData from '../components/console/PersonalData'
  // import Demand from '../components/console/Demand'
  // import Application from '../components/console/Application'
  // import Service from '../components/console/Service'
  import CHeader from '../components/console/header'
  import CMenu from '../components/console/menu'
  export default {
    data() {
      return {
        activeIndex: 0,
        val: ''
      }
    },
    // watch: {
    //   val: {
    //     handler(val) {
    //       this.val = val

    //     },
    //     immediate: true
    //   }
    // },
    components: {
      CHeader,
      CMenu,
      // PersonalData,
      // Demand,
      // Application,
      // Service
    },
    methods: {
      tabMenu(index) {
        this.activeIndex = index
      },
      getShow(res) {
      	this.val = res
      }
    }
  }
</script>
<style scoped>
  .content {
    display: flex;
    justify-content: flex-start;
  }

  .rightContent {
    width: 100%;
    height: calc(100vh - 80px);
    background: #F7F9FC;
  }
</style>



// WEBPACK FOOTER //
// src/views/console.vue